import CloudDetails from "../views/supportal/CloudDetailView/CloudDetails";
import useCloud from "../api/api-hooks/cloud/useCloud";
import AppNavbar from "../components/AppNavbar/AppNavbar";
import CloudDetailHeader from "../views/supportal/CloudDetailView/CloudDetailHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CloudUsers from "../views/supportal/CloudDetailView/CloudUsers";
import CloudFeed from "../views/supportal/CloudDetailView/CloudFeed";
import OverAllCloudCosts from "../views/supportal/BrieCostTracker/OverAllCloudCosts";
import CloudTenantSchemaView from "../views/supportal/CloudDetailView/TenantSchema/CloudTenantSchemaView";
import CloudBackupsList from "../views/supportal/CloudDetailView/CloudBackupsList";
import CloudAppsList from "../views/supportal/CloudDetailView/CloudApps/CloudAppsList";
import TenantSchemasList from "../views/supportal/CloudDetailView/TenantSchemasList";
import SkeletonLoader from "../elements/SkeletonLoader";

const cloudDetailTabs = [
  {
    title: "General",
    activeValue: "general",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Users",
    activeValue: "users",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Feed",
    activeValue: "feed",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Brie Cost Tracker",
    activeValue: "brie-cost-tracker",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Modules",
    activeValue: "modules",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Cloud Apps",
    activeValue: "cloud-apps",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Schema Records",
    activeValue: "schema-records",
    hidden: false,
    externalLink: "",
  },
  {
    title: "Backups",
    activeValue: "backups",
    hidden: false,
    externalLink: "",
  },
];

const SupportalCloudsLayout = ({
  urlStart,
  mode,
}: {
  urlStart: string;
  mode: "mc" | "supp";
}) => {
  const { cloudID } = useParams<{ cloudID: string }>();
  const { cloud, cloudPermissions, cloudLoading } = useCloud(cloudID || "");
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = location.pathname.split("/").pop();

  return (
    <div>
      <CloudDetailHeader
        cloud={cloud}
        loading={cloudLoading}
        urlStart={urlStart}
        mode={mode}
      />
      <div className="tw:mx-5">
        <AppNavbar
          tabs={
            mode === "mc"
              ? [
                  {
                    title: "General",
                    activeValue: "general",
                    hidden: false,
                    externalLink: "",
                  },
                ]
              : cloudDetailTabs
          }
          activeTab={activeTab}
          onSelect={(val: string) => navigate(`${urlStart}/${cloudID}/${val}`)}
        />
        {cloud ? (
          <>
            {activeTab === "general" && <CloudDetails cloud={cloud} />}
            {activeTab === "users" && (
              <div className="tw:mt-5">
                <CloudUsers
                  cloud={cloud}
                  cloudPermissions={cloudPermissions}
                  loading={cloudLoading}
                  urlStart={urlStart && urlStart.replace(/\/[^\/]+$/, "")}
                />
              </div>
            )}
            {activeTab === "feed" && <CloudFeed cloud={cloud} />}
            {activeTab === "brie-cost-tracker" && (
              <div className="tw:mt-5">
                <OverAllCloudCosts />
              </div>
            )}
            {activeTab === "modules" && (
              <div className="tw:mt-5">
                <CloudTenantSchemaView urlStart={urlStart} />
              </div>
            )}
            {activeTab === "cloud-apps" && (
              <div className="tw:mt-5">
                <CloudAppsList urlStart={urlStart} />
              </div>
            )}

            {activeTab === "schema-records" && <TenantSchemasList />}
            {activeTab === "backups" && <CloudBackupsList />}
          </>
        ) : (
          <SkeletonLoader width="100%" height="50vh" />
        )}
      </div>
    </div>
  );
};

export default SupportalCloudsLayout;
